<div id="contact-us" class="right-navigation showModal">
    <div class="component">
        <div class="header border-bottom">
            <div class="font-primary-subtitle bold contact-us-header">
                {{'pkg_filter_header' | translate}}
            </div>
            <div (click)="closeModal()" class="float-right closeicon pointer">
                <img src="./assets/icons/close_grey.svg">
            </div>
        </div>

        <div class="content">
            <div class="profile-section">
                <div class="options">
                    <div class="clinic-details-wrapper" *ngFor="let group of tempFilters; let i = index">
                        <div  class="card row cursor-pointer" *ngIf="!group.hideInModal" (click)="onSelectFilter(group)" [ngClass]="{ active: group.type === selectedFilter.type }">
                            <div class="card-content">
                                <ng-container>
                                    <div class="title cat-title">
                                        {{ group['label'] | translate}}
                                        <span class="count" *ngIf="getSelectedCount(group) > 0">
                                          ({{ getSelectedCount(group) }})
                                        </span>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="components">
                    <div class="filter-body">
                        <div *ngIf="selectedFilter" class="filter-group">
                            <div class="subcard row cursor-pointer" (click)="selectDeselectAll(selectedFilter)">
                                <div class="card-content">
                                    <ng-container>
                                        <div class="select-all-title">
                                            {{ 'select_deselect_all' | translate}}
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                            <div class="group-options" *ngIf="selectedFilter?.options?.length > 0">
                                <div class="subcard row cursor-pointer" *ngFor="let opt of selectedFilter.options" (click)="toggleOption(selectedFilter, opt)">
                                    <div class="card-content">
                                        <div class="title option-card">
                                            <div class="filter-icon show">
                                                <img class="pkg-image" *ngIf="!opt.selected"
                                                    src="./assets/icons/packages/checkbox.svg">
                                                <img class="pkg-image" *ngIf="opt.selected"
                                                    src="./assets/icons/packages/checkedbox.svg">
                                            </div>
                                            <div class="option-label">
                                                {{ opt.label | translate }}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>

            </div>
        </div>
        <div class="footer border-bottom">
            <div class="footer-primary-subtitle bold contact-us-header" (click)="clearAll()">
                {{'package_filter_clear_filter' | translate}}
            </div>
            <button (click)="applyFilter()" class="float-right applybtn pointer">
                {{'package_filter_Apply' | translate}}
            </button>
        </div>
    </div>
</div>